import ApisServiceApp from '@api/ApisServiceApp'
import ApisServiceAuth from '@api/ApisServiceAuth'
import { IUser , IUserUpdateRole} from '@interfaces/userInterfaces'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

export function createUser(data: IUser) {
  let bodyData: any = { ...data }
  const phoneNumber = data.phoneNumber || ""

  delete bodyData.phoneNumber
  if (phoneNumber.trim() != "") {
    bodyData.phone = { 
      phoneNumber: phoneNumber, 
      countryAccessCode: '84', }
  }
  if (!bodyData.birthDate) {
    delete bodyData.birthDate
  }
  return ApisServiceApp.post('/user/register', bodyData)
}

export async function login(username: string, password: string) {
  return await ApisServiceApp.post('/user/login', {
    username,
    password,
  })
}

export function updateProfile(data: IUser) {
  let bodyData: any = { ...data }
  const phoneNumber = data.phoneNumber || ""

  delete bodyData.phoneNumber
  if (phoneNumber.trim() != "") {
    bodyData.phone = { 
      phoneNumber: phoneNumber, 
      countryAccessCode: '84', }
  }
  if (!bodyData.birthDate) {
    delete bodyData.birthDate
  }
  return ApisServiceApp.put('/user/update-user-profile', bodyData)
}


export function updateUser(data: IUser) {
  let bodyData: any = { ...data }
  const phoneNumber = data.phoneNumber || ""

  delete bodyData.phoneNumber
  if (phoneNumber.trim() != "") {
    bodyData.phone = { 
      phoneNumber: phoneNumber, 
      countryAccessCode: '84', }
  }
  if (!bodyData.birthDate) {
    delete bodyData.birthDate
  }
  return ApisServiceApp.put('/user/update-user-profile/' + data.id, bodyData)
}


export function getUserInfo() {
  return ApisServiceApp.get('/user/get-user-info')
}

export function getDetailUser(id: string) {
  return ApisServiceApp.get('/user/get-user-info/' + id)
}

export function getListUser(querySt: any) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/user/filter-users', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}



export function changePassword({
  oldPassword,
  newPassword,
  newPasswordRetype,
}: {
  oldPassword: string
  newPassword: string
  newPasswordRetype: string
}) {
  return ApisServiceApp.post('/user/change-password', {
    oldPassword,
    newPassword,
    newPasswordRetype,
  })
}


export function getListRole(query: any) {
  return ApisServiceApp.get('/user/get-roles', {
    params: query,
  })
}

export function getListProject() {
  return ApisServiceApp.get('/user/get-my-duan-list')
}

export function changeProject(projectId: number) {
  return ApisServiceApp.put('/user/' + projectId + '/doi-duan')
}


export function updateRole(data: IUserUpdateRole) {
  const bodyData = {...data, role: data.role != "" ? data.role : null}
  return ApisServiceApp.put('/user/' + data.projectId + '/update-role-duan', bodyData)
}


export function changeBranch(duAnId: number, chiNhanhId: number) {
  return ApisServiceAuth.put('/user/' + duAnId + '/' + chiNhanhId + '/doi-chinhanh')
}

export function getListHeThong() {
  return ApisServiceApp.get('/hethong/filter-hethong')
}

export function getListProjectBySystem(query: any) {
  return ApisServiceApp.get('/project/list', {
    params: query
  })
}

export function getListBranch(query: any) {
  return ApisServiceApp.get('/branch/list', {
    params: query
  })
}

export function getListRoleGroup() {
  return ApisServiceApp.get('/role-group/list')
}

export function updateUserRole(data: {
  userId: number,
  duAnId: number,
  chiNhanhId: number,
  nhomQuyenId: number
}) {
  return ApisServiceApp.post('/user/phanquyen', data)
}


export function getMyMenu() {
  return ApisServiceApp.get('/user/get-my-menu')
}

export function getMyChiNhanh() {
  return ApisServiceApp.get('/user/get-my-chi-nhanh')
}

export function getMyDuAn() {
  return ApisServiceApp.get('/user/get-my-duan')
}

export function syncUser() {
  return ApisServiceApp.post('/user/sync/all-users')
}


